/* ==========================================================================
   go-before-after.js
   - Toggle de fases (pills) -> muestra/oculta paneles
   - Slider antes/después arrastrable (pointer events)
   Aislado por sección. Idempotente (no re-inicializa).
   ========================================================================== */
(function () {
  'use strict';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initSlider(slider) {
    var divider = slider.querySelector('[data-ba-divider]');
    if (!divider) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = slider.getBoundingClientRect();
      if (rect.width === 0) return;
      var pct = ((clientX - rect.left) / rect.width) * 100;
      slider.style.setProperty('--ba-pos', clamp(pct, 0, 100) + '%');
    }

    function onDown(e) {
      dragging = true;
      slider.setPointerCapture && e.pointerId != null && slider.setPointerCapture(e.pointerId);
      setPos(e.clientX);
    }

    function onMove(e) {
      if (!dragging) return;
      setPos(e.clientX);
    }

    function onUp() {
      dragging = false;
    }

    slider.addEventListener('pointerdown', onDown);
    slider.addEventListener('pointermove', onMove);
    slider.addEventListener('pointerup', onUp);
    slider.addEventListener('pointercancel', onUp);
    slider.addEventListener('pointerleave', onUp);

    // Teclado en el handle
    var handle = slider.querySelector('[data-ba-handle]');
    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(slider.style.getPropertyValue('--ba-pos')) || 50;
        if (e.key === 'ArrowLeft') {
          slider.style.setProperty('--ba-pos', clamp(current - 5, 0, 100) + '%');
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          slider.style.setProperty('--ba-pos', clamp(current + 5, 0, 100) + '%');
          e.preventDefault();
        }
      });
    }
  }

  function initSection(section) {
    if (section.dataset.baInit === '1') return;
    section.dataset.baInit = '1';

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ba-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ba-panel]'));

    function activate(index) {
      tabs.forEach(function (tab) {
        var on = tab.dataset.baTab === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.dataset.baPanel === String(index);
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.baTab);
      });
    });

    section.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-go-before-after]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init al cargar/seleccionar la sección
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
